import { Component, OnInit, OnDestroy, AfterContentInit, ContentChild, ContentChildren, QueryList, EventEmitter, ElementRef, Output } from '@angular/core';
import { ActionGroupComponent } from '../action-group/action-group.component';
import { ToolActionsComponent } from '../tool-actions/tool-actions.component';
import { Subscription } from 'rxjs';
import { ActionGroupEvent } from 'src/app/types/actiongroupevent';
import { StatefulCSS } from 'src/app/model/stateful_css';


@Component({
	selector: 'app-tool-set',
	templateUrl: './tool-set.component.html',
	styleUrls: ['./tool-set.component.scss']
})
export class ToolSetComponent implements OnInit, OnDestroy, AfterContentInit {
	private subscriptions: Array<Subscription> = [];
	private viewStates: StatefulCSS = new StatefulCSS();
	private activeToolName: string;

	@ContentChild(ActionGroupComponent, { static: false }) tools: ActionGroupComponent;
	@ContentChildren(ToolActionsComponent) toolActions !: QueryList<ToolActionsComponent>;
	@Output() actions: EventEmitter<any> = new EventEmitter();

	constructor(private domNode: ElementRef) { }

	ngOnInit() {
		this.viewStates.SetPrefix('tool-set-view');
		this.viewStates.SetMachine(this.domNode.nativeElement);
		this.viewStates.AddState('waiting');
		this.viewStates.AddState('all');
		this.viewStates.AddState('group');
		this.viewStates.AddState('group-hidden');
		this.viewStates.SetState('waiting');
	}
	ngAfterContentInit() {
		if (!!this.tools) {
			this.tools.ToggleClass('tool-options', true);
			this.subscriptions.push(this.tools.actions.subscribe((data: ActionGroupEvent) => {
				this.SyncViewState();
				if (data.action === 'tools') {
					this.tools.Toggle();
					this.tools.ToggleClass('tool-selected', false);
					return;
				}

				const toolName = data.action.split('/').pop();
				this.tools.ToggleClass('tool-selected', false);
				this.toolActions.forEach((item: ToolActionsComponent, index: number, src: ToolActionsComponent[]) => {
					item.ToggleActive(item.tool.toLowerCase() === toolName);
					if (item.tool.toLowerCase() === toolName) {
						this.tools.ToggleClass('tool-selected', true);

					}
				});
				this.actions.emit(data);
			}));
		}
		this.toolActions.forEach((item: ToolActionsComponent, index: number, src: ToolActionsComponent[]) => {
			this.subscriptions.push(item.actions.subscribe((data: any) => {
				this.actions.emit(data);
			}));
		});
		if (!!this.tools) {
			this.tools.SetFirst();
		}
	}
	SetActiveByName(toolName: string) {

		this.toolActions.forEach((item: ToolActionsComponent, index: number, src: ToolActionsComponent[]) => {
			if (!!item.name) {
				item.ToggleActive(item.name === toolName);
			} else {
				if (!!item.tool) {
					item.ToggleActive(item.tool === toolName);
				}
			}

		});
	}
	SetActive(tool: ToolActionsComponent) {

		this.toolActions.forEach((item: ToolActionsComponent, index: number, src: ToolActionsComponent[]) => {
			item.ToggleActive(item.name === tool.name);

			this.SyncViewState();
		});
	}
	SyncViewState() {
		this.viewStates.SetState(this.tools.viewState);
	}
	ngOnDestroy() {
		for (const action of this.subscriptions) {
			action.unsubscribe();
		}
	}


}
